import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsExclamationTriangle } from "react-icons/bs";

/**
 * Shared wizard footer: Back + primary Next CTA.
 * When the next action is blocked, the button stays clickable so we can
 * explain what is missing instead of silently doing nothing.
 * Sits flush at the bottom of StepPanel.
 */
const WizardNav = ({
	onBack,
	onNext,
	onNextBlocked,
	backLabel = "← Back",
	nextLabel = "Continue →",
	nextDisabled = false,
	nextDisabledReason,
	backDisabled = false,
	hideBack = false,
	hideNext = false,
	busy = false,
	busyLabel = "Please wait…",
	extra = null,
}) => {
	const handleNext = () => {
		if (busy) return;
		if (nextDisabled) {
			onNextBlocked?.(nextDisabledReason);
			return;
		}
		onNext?.();
	};

	const blocked = nextDisabled && !busy;

	return (
		<footer className="bg-white">
			{blocked && nextDisabledReason ? (
				<div
					className="mb-2 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900"
					role="status"
					aria-live="polite"
				>
					<BsExclamationTriangle
						className="mt-0.5 h-3.5 w-3.5 flex-shrink-0"
						aria-hidden
					/>
					<span>{nextDisabledReason}</span>
				</div>
			) : null}
			<div className="flex flex-wrap items-center justify-end gap-2">
				{!hideBack ? (
					<button
						type="button"
						className="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50 disabled:opacity-50"
						onClick={onBack}
						disabled={backDisabled || busy}
					>
						{backLabel}
					</button>
				) : null}
				{extra}
				{!hideNext ? (
					<button
						type="button"
						className={`inline-flex items-center justify-center gap-2 rounded-lg px-5 py-2 text-sm font-semibold shadow-sm transition focus:outline-none focus:ring-2 focus:ring-akgreen focus:ring-offset-2 ${
							busy
								? "cursor-wait bg-akgreen text-white opacity-50"
								: blocked
								? "cursor-pointer border border-gray-300 bg-gray-200 text-gray-600 hover:bg-gray-300"
								: "bg-akgreen text-white hover:bg-akgreener"
						}`}
						onClick={handleNext}
						disabled={busy}
						aria-disabled={blocked || busy}
						title={blocked ? nextDisabledReason : undefined}
					>
						{busy ? (
							<>
								<AiOutlineLoading3Quarters
									className="h-4 w-4 animate-spin"
									aria-hidden
								/>
								{busyLabel}
							</>
						) : (
							nextLabel
						)}
					</button>
				) : null}
			</div>
		</footer>
	);
};

export default WizardNav;
